import * as API from '.'

let url = 'api/institution/';

export default {
    addInstitution:params=>{
        return API.POST( url + 'addInstitution', params)
    },
    updateInstitution: params => {
        return API.POST( url + 'updateInstitution', params)
    },
    delInstitution: params => {
        return API.POST( url + 'delInstitution', params)
    },
    getInstitution: params => {
        return API.POST( url + 'getInstitution', params)
    },
    getInstitutions: params => {
        return API.POST( url + 'getInstitutions', params)
    },
    getAuditInstitutions: params => {
        return API.POST( url + 'getAuditInstitutions', params)
    }
}


// WEBPACK FOOTER //
// ./src/api/api_institution.js